<template>
	<GChart
    type="AreaChart"
    :data="data"
    :options="chartOptions"
	class="line-chart"
	v-if="data.filter((el) => el[1] !== null).length > 1"
  />
  <div v-else class="no-data">
	<p>немає даних</p>
  </div>
</template>
  
<script>
import { GChart } from 'vue-google-charts'

export default {
	name: 'LineChartBase',
	components: {
		GChart
	},
	ticks: {
		Boolean,
		default: () => null
	},
	props: {
		color: {
			String,
			default: () => '0, 0, 0'
		},
		data: {
				Object,
				default: () => {}
		}
	},
	data() {
		return {
			chartOptions: {
				colors: [`rgb(${this.color})`],
				pointSize: 5,
				focusTarget: 'category',
				fontName: 'Roboto',
				fontSize: 12,
				interpolateNulls: true,
				legend: {
					position: 'none'
				},
				tooltip: {
					// trigger: 'none'
				},
				hAxis: {
					gridlines: {
						color: 'black',
						minSpacing: 20,
						count: 8,
						gridlines: {
							units: {
								years: {format: ['yyyy']},
							}
						}			
					},
					format: 'auto',
				},
				vAxis: {
					ticks: this.ticks,
					minValue: 75,
					maxValue: 100,
					showTextEvery: 1,
				},
				width: '100%',
				height: '100%',
				chartArea: {
					width: '100%',
					height: '100%',
					top: 10,
					left: 30,
					right: 30,
					bottom: 30,
				},
			}
		}
	},
	computed: {
	},
	methods: {
	},
	mounted() {
	},
	watch: {
		data: {
			handler: function () {
				this.chartOptions.colors = [`rgb(${this.color})`]
			},
			deep: true
		}
	}
}
</script>

<style lang="sass">
.line-chart
	width: 100%

.no-data
	display: block
	margin-top: 80px
	text-align: center
	color: rgb(44, 62, 80)
</style>
